import template from './notesList.template.html';

export default {
  template,
  bindings: {
    notes: '=',
    accounts: '=',
    contacts: '<',
    partners: '<',
    labels: '=',
    workflows: '<',
    tickets: '<',
    onClick: '&',
    onDelete: '&',
    onShareClient: '&',
    onSharePartner: '&',
    onPin: '&',
    onLabelsSelect: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, listServiceNew, fileFactory, NOTE) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.showsInAll = ctrl.showsInAll !== undefined;
        ctrl.contacts = ctrl.contacts ? ctrl.contacts : [];
        ctrl.partners = ctrl.partners ? ctrl.partners : [];
        ctrl.workflows = ctrl.workflows ? ctrl.workflows : [];
        ctrl.tickets = ctrl.tickets ? ctrl.tickets : [];

        ctrl.list.setData(ctrl.notes);
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.notePin = ($event, data) => {
        ctrl.onPin({ event: $event, data });
      };

      ctrl.noteShareClient = ($event, data) => {
        ctrl.onShareClient({ event: $event, data });
      };

      ctrl.noteSharePartner = ($event, data) => {
        ctrl.onSharePartner({ event: $event, data });
      };

      ctrl.noteLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.noteEdit = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };

      ctrl.noteDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.downloadAttachment = (data, noteType) => {
        if (noteType.name !== 'video') {
          fileFactory
            .getDownloadUrl({ url: NOTE.API.DOWNLOAD, file: data.file, name: data.name })
            .then((downloadUrl) => {
              fileFactory.download(downloadUrl);
            });
        } else {
          fileFactory
            .getDownloadVideoUrl({
              url: NOTE.API.DOWNLOAD_VIDEO,
              idAttachment: data.id,
              file: data.file,
              name: data.name
            })
            .then((downloadUrl) => {
              fileFactory.download(downloadUrl);
            });
        }
      };

      ctrl.downloadAttachmentPdf = (data, noteType) => {
        if (noteType.name !== 'video') {
          fileFactory
            .getDownloadUrl({ url: NOTE.API.DOWNLOAD_PDF, file: data.file, name: data.name })
            .then((downloadUrl) => {
              fileFactory.download(downloadUrl, true);
            });
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.notes && changes.notes.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
